var _path, _path2, _path3, _ellipse, _path4, _defs, _clipPath, _g, _g2, _path5, _ellipse2, _path6, _defs2, _clipPath2, _g3, _g4, _path7, _ellipse3, _path8, _defs3, _clipPath3, _g5, _g6, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.1 81.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EB5F72",
    d: "M20.1,74.3c-0.2,0-0.5,0.1-0.6,0.2c-0.2,0.1-0.3,0.4-0.2,0.6c0,0.2,0.1,0.5,0.2,0.6 c0.2,0.2,0.4,0.3,0.6,0.4l0.8,0.2c0.3,0.1,0.6,0.2,0.9,0.3c0.3,0.1,0.6,0.2,0.8,0.4c0.3,0.2,0.5,0.4,0.6,0.7 c0.2,0.3,0.2,0.7,0.2,1.1c0,0.7-0.3,1.4-0.9,1.9c-0.7,0.5-1.5,0.8-2.4,0.8c-0.8,0-1.7-0.2-2.4-0.7c-0.6-0.5-0.9-1.2-0.9-2h2.2 c0,0.6,0.4,1,1,1c0,0,0,0,0.1,0c0.3,0,0.5-0.1,0.7-0.2c0.2-0.2,0.3-0.4,0.3-0.6c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.2-0.4-0.3-0.6-0.4 c-0.2-0.1-0.5-0.2-0.8-0.2s-0.6-0.2-0.9-0.3c-0.3-0.1-0.6-0.2-0.8-0.4c-0.3-0.2-0.5-0.4-0.6-0.7C17,76,16.9,75.6,17,75.3 c0-0.7,0.3-1.5,0.9-1.9c0.7-0.5,1.5-0.8,2.3-0.7c0.8,0,1.6,0.2,2.3,0.6c0.6,0.5,0.9,1.2,0.9,2H21c0-0.3-0.1-0.5-0.3-0.7 C20.5,74.4,20.3,74.3,20.1,74.3z M28.1,79.6h0.8v1.8h-1.1c-0.6,0-1.3-0.1-1.8-0.5c-0.5-0.5-0.7-1.1-0.6-1.8v-2.8h-0.6v-1.8h0.6 v-1.7h2.1v1.7h1.4v1.8h-1.4v2.8C27.4,79.5,27.6,79.6,28.1,79.6L28.1,79.6z M34.4,79.2c0.3-0.3,0.5-0.8,0.5-1.3 c0-0.5-0.2-0.9-0.5-1.2c-0.3-0.3-0.7-0.4-1-0.4c-0.4,0-0.8,0.2-1,0.4c-0.3,0.3-0.5,0.8-0.5,1.3c0,0.5,0.1,0.9,0.5,1.2 c0.3,0.3,0.6,0.4,1,0.4C33.7,79.7,34.1,79.5,34.4,79.2L34.4,79.2z M30.7,80.5c-1.2-1.5-1.2-3.5,0-5c0.6-0.6,1.4-1,2.2-1 c0.8,0,1.5,0.3,2,1v-0.9H37v6.9h-2.1v-1c-0.4,0.7-1.2,1.1-2,1.1C32,81.6,31.2,81.2,30.7,80.5L30.7,80.5z M41,81.4h-2.2v-9.1h2.1 v5.1l2.1-2.9h2.8l-2.9,3.5l2.9,3.4h-2.8l-2.2-2.8L41,81.4z M49.8,81.5c-0.9,0-1.8-0.3-2.5-1c-0.7-0.7-1-1.6-1-2.6 c0-1,0.3-1.9,1-2.6c0.7-0.6,1.6-1,2.5-0.9c0.9,0,1.8,0.3,2.5,0.9c0.7,0.7,1.1,1.6,1,2.6c0,0.2,0,0.4,0,0.7h-4.8 c0.1,0.6,0.6,1,1.2,1c0.2,0,0.4,0,0.6-0.1c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.2,0.2-0.3H53c-0.2,0.7-0.6,1.3-1.2,1.7 C51.2,81.2,50.5,81.5,49.8,81.5L49.8,81.5z M51.1,77.4c0-0.3-0.2-0.6-0.4-0.8c-0.2-0.2-0.6-0.3-0.9-0.3c-0.3,0-0.6,0.1-0.8,0.3 c-0.2,0.2-0.4,0.5-0.4,0.8H51.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DB4D65",
    d: "M38.1,6.1c1.2,1,2.7,2.5,5.6,5.4c2,2.2,3.5,4.8,4.5,7.5c0.3,0.9,0,1.9-0.6,2.5c-0.8,0.9-3,0.5-4.2-0.5 c-5.8-4.6-6.4-8.5-10.8-10.1c-1.4-0.6-3-0.8-4.5-0.7c-3.2,0.3-5,1.7-5.2,1.1c-0.3-1.2,4.3-7.8,8.6-8.7C33.3,2.4,35,3.6,38.1,6.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E28328",
    d: "M52.3,40.2V40c0-0.2,0-0.3-0.1-0.4c-0.1-0.2-0.3-0.3-0.6-0.3l-2.7,0l-6.6-0.1l-8-0.1L27.4,39 c-1.1,0-2.3,0-3.4,0h0c-0.4,0-0.7,0.2-0.7,0.6l0.3,5.9c0,0.4,0.1,0.8,0.2,1.2c0.3,0.6,0.7,1.2,1.3,1.6c1.5,1.2,3.4,1.8,5.2,2.3 c2.5,0.6,5.1,0.9,7.7,0.9c2.4,0,4.8-0.2,7.2-0.6c1.8-0.4,3.7-0.9,5.2-1.9c1-0.6,1.8-1.5,1.9-2.7C52.3,44.2,52.3,42.2,52.3,40.2 L52.3,40.2z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.01658 -.9999 .9999 .01658 -2.77 77.074)",
    fill: "#EAF471",
    cx: 37.8,
    cy: 39.9,
    rx: 6.3,
    ry: 14.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6BE4E",
    d: "M37.6,45.6c7.6,0.2,13.8-2.2,13.8-5.4s-6-6-13.5-6.3s-13.8,2.2-13.9,5.4S30,45.3,37.6,45.6L37.6,45.6z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M37.6,45.6c7.6,0.2,13.8-2.2,13.8-5.4s-6-6-13.5-6.3c-7.5-0.2-13.8,2.2-13.9,5.4S30,45.3,37.6,45.6 L37.6,45.6z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E38329",
    d: "M51.3,39.2c1.6,2.8-3,5.6-10.2,6.2c-7.2,0.6-14.6-1.2-16.2-4c3.3,1.9,9.2,2.8,14.8,2.4 C45.7,43.4,50.3,41.6,51.3,39.2C51.3,39.2,51.3,39.2,51.3,39.2z",
    opacity: 0.69
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#313076"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-88.26 32.349 39.364) scale(.99996)",
    cx: 32.3,
    cy: 39.4,
    rx: 0.4,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-88.26 43.26 39.69) scale(.99996)",
    cx: 43.3,
    cy: 39.7,
    rx: 0.4,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8,39.7c-0.2,0-0.4,0.1-0.5,0.2c0,0.1,0.1,0.3,0.4,0.4c0.3,0.1,0.6,0.2,0.9,0.2c0.3,0,0.6,0,0.9-0.1 c0.1,0,0.2-0.1,0.3-0.2S39,40,38.9,40c0-0.1-0.2-0.2-0.4-0.2C37.9,39.8,37.3,39.8,36.8,39.7"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E28328",
    d: "M52.3,33.4v-0.2c0-0.2,0-0.3-0.1-0.4c-0.1-0.2-0.3-0.3-0.6-0.3l-2.7,0l-6.6,0.1l-8,0.1l-6.9,0.1 c-1.1,0-2.3,0-3.4,0h0c-0.4,0-0.7,0.3-0.7,0.6l0.4,5.9c0,0.4,0.1,0.8,0.2,1.2c0.3,0.6,0.8,1.1,1.3,1.5c1.5,1.1,3.4,1.7,5.3,2.1 c2.5,0.5,5.2,0.8,7.8,0.7c2.4,0,4.8-0.3,7.2-0.8c1.8-0.4,3.7-1,5.2-2c1-0.6,1.8-1.6,1.8-2.7C52.4,37.5,52.3,35.5,52.3,33.4z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -.0082 .0082 1 -.274 .31)",
    fill: "#EAF471",
    cx: 37.7,
    cy: 33.6,
    rx: 14.6,
    ry: 6.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6BE4E",
    d: "M37.7,39.2c7.6,0,13.7-2.5,13.7-5.8s-6.1-5.9-13.7-5.9C30.2,27.5,24,30,24,33.3S30.1,39.1,37.7,39.2 L37.7,39.2z"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M37.7,39.2c7.6,0,13.7-2.5,13.7-5.8s-6.1-5.9-13.7-5.9c-7.6,0-13.7,2.5-13.7,5.8S30.1,39.2,37.7,39.2 L37.7,39.2z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    overflow: "visible"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E38329",
    d: "M51.3,32.5c1.7,2.8-2.8,5.7-10.1,6.5c-7.2,0.8-14.6-0.8-16.3-3.6c3.4,1.8,9.2,2.6,14.9,2 C45.7,36.9,50.3,34.9,51.3,32.5L51.3,32.5z",
    opacity: 0.69
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#313076"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.00559 -1 1 .00559 -1.059 65.226)",
    cx: 32.3,
    cy: 33.1,
    rx: 0.4,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(.00559 -1 1 .00559 9.74 76.187)",
    cx: 43.2,
    cy: 33.2,
    rx: 0.4,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7,33.4c-0.2,0-0.4,0.1-0.4,0.2c0,0.1,0.1,0.3,0.4,0.4c0.3,0.1,0.6,0.1,0.9,0.1c0.3,0,0.6,0,0.9-0.1 c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.1,0.1-0.2s-0.2-0.1-0.4-0.1C37.8,33.4,37.3,33.4,36.7,33.4"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E28328",
    d: "M54.1,26l0.1-0.2c0.1-0.1,0.1-0.3,0-0.4c0-0.2-0.2-0.4-0.4-0.5l-2.5-1l-6.1-2.5l-7.4-3l-6.4-2.6 c-1-0.4-2.1-0.9-3.1-1.3l0,0c-0.3-0.2-0.8,0-0.9,0.3l-1.9,5.5c-0.1,0.4-0.2,0.8-0.2,1.2c0,0.7,0.2,1.3,0.6,1.9 c0.9,1.6,2.5,2.9,4,4c2.1,1.5,4.4,2.8,6.8,3.7c2.2,0.9,4.6,1.6,6.9,2.1c1.8,0.3,3.7,0.5,5.5,0.2c1.1-0.2,2.3-0.8,2.7-1.8 C52.5,29.8,53.3,27.9,54.1,26L54.1,26z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-67.33 40.65 20.462)",
    fill: "#EAF471",
    cx: 40.6,
    cy: 20.5,
    rx: 6.3,
    ry: 14.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6BE4E",
    d: "M38.4,25.6c6.9,3,13.6,3,14.9,0.1S50,17.9,43.1,14.9s-13.6-3.1-14.9-0.1S31.5,22.6,38.4,25.6z"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M38.4,25.6c6.9,3,13.6,3,14.9,0.1S50,17.9,43.1,14.9s-13.6-3.1-14.9-0.1S31.5,22.6,38.4,25.6z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    overflow: "visible"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E38329",
    d: "M53.5,24.8c0.5,3.2-4.8,4.1-11.8,2s-13.1-6.5-13.6-9.7c2.4,3,7.5,6,12.9,7.7 C46.7,26.6,51.7,26.6,53.5,24.8L53.5,24.8L53.5,24.8z",
    opacity: 0.69
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#313076"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-66.54 35.811 17.901)",
    cx: 35.8,
    cy: 17.9,
    rx: 0.4,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-66.54 45.827 22.25)",
    cx: 45.8,
    cy: 22.2,
    rx: 0.4,
    ry: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8,19.9c-0.2-0.1-0.4-0.1-0.5,0c-0.1,0.1,0,0.3,0.2,0.5c0.2,0.2,0.5,0.4,0.8,0.5 c0.3,0.1,0.6,0.2,0.9,0.2c0.2,0,0.3,0,0.3,0c0.1,0,0.2-0.1,0.2-0.2s-0.2-0.2-0.3-0.3C40.8,20.4,40.3,20.1,39.8,19.9"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#EE8097",
    d: "M10.4,1c5.1-0.9,15.5-2.3,26.5,1.5c4.3,1.3,8.3,3.4,11.8,6.1c6,4.6,7.5,5.8,7.4,7.4c-0.1,0.8-0.5,1.6-1.3,2 c-1.2,0.5-2.8-1.1-3.5-1.7c-3.3-2.9-7-4.2-11.7-5.9c-3.6-1.3-7.5-1.7-11.2-1c-2.1,0.4-3.2,1.1-3.9,2.2c-0.5,1.1-0.6,2.4-0.2,3.5 c0.4,1.2,1.5,1.3,6.2,3.6c1.8,0.9,2.8,1.4,2.8,2.2c-0.1,0.8-0.5,1.6-1.3,2c-1.9,1.1-3.9-0.8-8.6-2.5c-2.7-0.9-5.5-1.5-8.3-1.8 c-5-0.7-5.4,0-7.7-0.8c-2.7-0.9-7.1-3.6-7.4-7.1C-0.4,6.8,3.8,2.1,10.4,1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M4.9,9.2c0.9,1.8,2.4,3.3,4.3,4.3c1.4,0.7,2.1,0.6,4.5,1.1c2.8,0.6,5.5,1.5,8.1,2.8c4.2,1.9,4.3,2.8,6.6,3.2 c1.6,0.3,3.2,0.2,4.7-0.3c-0.8-0.7-1.6-1.2-2.6-1.6c-4.2-2-5.6-2.3-6.1-3.2c0,0.3,0,0.6,0,0.8c-1.2-1.3-1.9-3.1-2-4.9 c0-1.3,0.3-2.5,0.8-3.6c2.9-0.6,5.8-0.8,8.8-0.6c6.9,0.3,13.6,2.8,19,7.1c0.9,0.8,1.8,1.6,2.6,2.5c0.3,0.2,0.7,0.2,1,0.3 c0.5,0,0.9-0.1,1.3-0.3c0.1-0.2,0.1-0.4,0.1-0.6c0.1-1.5-1.4-2.8-7.4-7.4c-3.5-2.8-7.6-4.9-11.9-6.2C25.9-1.2,15.5,0.1,10.4,1 c-2,0.3-4,1-5.7,2.1C4,5.1,4.1,7.3,4.9,9.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB5F72",
    d: "M28.4,20.6c-2.3-0.4-2.5-1.3-6.6-3.2c-2.6-1.2-5.3-2.2-8.1-2.8c-2.4-0.5-3.1-0.4-4.5-1.1 c-1.8-0.9-3.3-2.4-4.3-4.3C4.1,7.3,4,5.1,4.7,3.1c-3.2,2-4.9,4.9-4.6,7.5c0.3,3.5,4.7,6.2,7.4,7.1c2.3,0.8,2.7,0.1,7.7,0.8 c2.8,0.3,5.6,0.9,8.3,1.8c4.7,1.6,6.7,3.5,8.6,2.5c0.8-0.4,1.2-1.2,1.3-2c0-0.2-0.1-0.4-0.2-0.6C31.6,20.7,30,20.8,28.4,20.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#EB5F72",
    d: "M53.7,16.7C52.8,15.8,52,15,51,14.2C45.6,9.9,39,7.4,32,7.1c-2.9-0.1-5.9,0.1-8.8,0.7 c-0.6,1.1-0.9,2.4-0.9,3.6c0.1,1.8,0.8,3.6,2,4.9c0-0.3,0-0.6,0-0.8c-0.1-0.1-0.1-0.2-0.1-0.3c-0.4-1.1-0.3-2.4,0.2-3.5 c0.6-1.1,1.8-1.8,3.9-2.2c3.8-0.7,7.6-0.3,11.2,1c4.7,1.7,8.4,3.1,11.7,5.9c0.7,0.6,2.3,2.1,3.5,1.7c0.6-0.3,1-0.8,1.2-1.4 c-0.4,0.2-0.9,0.4-1.3,0.3C54.3,16.9,54,16.8,53.7,16.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStake);
export default __webpack_public_path__ + "static/media/stake.6b5374cb.svg";
export { ForwardRef as ReactComponent };